import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Event } from '../api/events/Event';

export const appInsights = new ApplicationInsights({
    config: {
        connectionString: APPLICATION_INSIGHTS_CONNECTION_STRING,
        disableAjaxTracking: true,
        disableCorrelationHeaders: true,
        disableFetchTracking: true,
        disableExceptionTracking: true,
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
        namePrefix: 'bri-app-insights',
        accountId: ACCOUNT_ID,
        appId: 'brilliant-client',
        cookieCfg: {
            enabled: true
        }
    }
});
appInsights.loadAppInsights();

if (ENABLE_EVENTS_APPLICATION_INSIGHTS) {
    const eventTypes: Record<Event['type'], null> = {
        'bri.click_add_product_to_cart': null,
        'bri.change_comparing_products': null,
        'bri.change_search_result_filter': null,
        'bri.click_active_help': null,
        'bri.click_go_to_cart': null,
        'bri.click_product_card_action': null,
        'bri.click_product_card': null,
        'bri.click_view_more_products': null,
        'bri.close_active_help': null,
        'bri.init_success': null,
        'bri.show_main_button': null,
        'bri.start_search': null,
        'bri.input_chat': null,
        'bri.open_comparison': null,
        'bri.open_search_result': null,
        'bri.open_add_many_products_to_cart': null,
        'bri.view_active_help': null,
        'bri.view_product_detail': null,
        'bri.click_widget_item': null,
        'bri.close_widget': null,
        'bri.close_main_window': null,
        'bri.open_widget': null,
        'bri.upload_image': null,
        'bri.click_suggested_question': null
    };
    for (const eventType of Object.keys(eventTypes)) {
        document.addEventListener(eventType, event => {
            const { detail } = event as CustomEvent<Event>;
            const { type, ...rest } = detail;
            appInsights.trackEvent({ name: type, properties: rest });
        });
    }
}
